import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface ICustomerGroupSelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  value: string | string[] | undefined;
  customerGroupList?: Array<GQL.ICustomerGroup>;
  style?: any;
  mode?: "multiple" | "tags" | undefined;
  placeholder?: string | undefined;
  onChange: (e: any, customerGroup: GQL.ICustomerGroup | GQL.ICustomerGroup[] | undefined) => void;
}

export class CustomerGroupSelect extends React.PureComponent<ICustomerGroupSelectProps> {

  constructor(props: ICustomerGroupSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, customerGroupList } = this.props;

    if (customerGroupList) {
      // objekt vybrané skupiny
      const customerGroup = customerGroupList.find((g: GQL.ICustomerGroup) => g.id === value || g.name === value);

      return (
        <Select
          placeholder={this.props.placeholder?this.props.placeholder:'Choose customer group'}
          onChange={this.onChange}
          value={customerGroup ? customerGroup.id : value}
          style={...style}
          allowClear={true}
          mode={this.props.mode}
        >
          {customerGroupList
            .map(l => {
              return (
                <Select.Option key={l.id} value={l.id}>
                  {l.name}
                </Select.Option>
              );
            })}
        </Select>
      );
    }

    return (
      <Select placeholder={'Choose customer group'} style={...style} />
    );
  }

  private onChange(value: string|string[]) {
    const { customerGroupList } = this.props;

    const customerGroup = customerGroupList && customerGroupList.find((l: GQL.ICustomerGroup) => l.id === value);
    let customerGroups:GQL.ICustomerGroup[]|null = null;
    if(Array.isArray(value)){
      customerGroups = [];
      value.forEach((valueItem)=>{
        let customerGroup = customerGroupList && customerGroupList.find((l: GQL.ICustomerGroup) => l.id === valueItem);
        if(customerGroup && Array.isArray(customerGroups)){
          customerGroups.push(customerGroup);
        }
      });
    }

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: Array.isArray(customerGroups)?customerGroups : value,
        }
      }, customerGroup);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/CustomerGroupSelect/CustomerGroutSelect.tsx